export const fetchUniformManifest = async manifestUrl => {
  try {
    const url = manifestUrl || 'https://cdn.argos.co.uk/assets/personalisation/manifest.json'
    const data = await fetch(url)
    const json = await data.json()
    return json
  } catch (error) {
    console.error('Error fetching manifest', error)
  }
  return null
}
